var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUnlock = function SvgIconUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 9.477H5a1 1 0 0 0-1 1.001v10.018a1 1 0 0 0 1 1.001h14a1 1 0 0 0 1-1.001V10.478a1 1 0 0 0-1-1.001M5 8.475c-1.105 0-2 .897-2 2.003v10.018c0 1.106.895 2.003 2 2.003h14c1.105 0 2-.897 2-2.003V10.478a2 2 0 0 0-2-2.003z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.246 4.77c-.968-.876-1.623-1.113-2.292-1.223-.93-.153-1.72.083-2.25.561-.531.48-.848 1.241-.794 2.184.034.582.162 1.165.685 1.987.215.338-.008.805-.408.809a.47.47 0 0 1-.396-.21c-.629-.969-.832-1.726-.879-2.528-.07-1.201.334-2.275 1.123-2.986s1.897-1 3.082-.805c.91.15 1.739.5 2.832 1.498a.487.487 0 0 1-.01.721.52.52 0 0 1-.693-.008"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.705 15.361a1.277 1.277 0 0 0-.63-2.388h-.027a1.276 1.276 0 0 0-.618 2.38v2.09a.638.638 0 1 0 1.275 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconUnlock;